import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

import { ActionForm } from './ActionForm'
import { ActionMenu } from './ActionMenu'
import { useActionPanel } from './ActionPanelProvider'
import { getActionFormWidth } from './getActionPanelWidth'
import { Panel } from './ui'

/**
 * The action column's two halves: the `ActionForm` — every route a row can take
 * to a single control — and the `ActionMenu` of icon actions beside it.
 *
 * The menu is a sibling of the form, not a child: the form's auction branch only
 * mounts for live 3MP auctions, and the actions have to work on ended, CONTRACT,
 * Make-an-Offer and ineligible rows too.
 */
export const ListViewActionPanel = ({
  isSentinel,
  searchListing,
}: {
  isSentinel: boolean
  searchListing: CombinedListingSearchResult
}) => {
  const { variant } = useActionPanel()

  return (
    <Panel $formWidth={getActionFormWidth(variant)}>
      <ActionForm isSentinel={isSentinel} searchListing={searchListing} />
      <ActionMenu searchListing={searchListing} />
    </Panel>
  )
}
